import { useTranslation } from "react-i18next";
import "./CallToActionBlock.css";
import CallToActionButton from "./callToActionButton/CallToActionButton";

export default function CallToActionBlock({ attachmentBlock, blockStyles }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "callToActionBlock",
  });
  const isPhilosophyBlock = attachmentBlock === "PhilosophyBlock";

  return (
    <div className={`call-to-action-block__wrapper${isPhilosophyBlock ? " call-to-action-block__wrapper--philosophy" : ""}`}>
      <div className="call-to-action-block" style={blockStyles}>
        {isPhilosophyBlock && (
          <span className="call-to-action-block__eyebrow">ACTIVE GENERATION</span>
        )}
        <p
          className="call-to-action-block__text-content"
          style={{
            width: isPhilosophyBlock ? "58%" : "100%",
          }}
        >
          {t(`textContent${attachmentBlock}`)}
        </p>
        <CallToActionButton attachmentBlock={attachmentBlock} />
      </div>
    </div>
  );
}
